import { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { CustomLoadingButton } from "../ui/CustomButton";
import { useSelector } from "react-redux";
import "../../style.scss";

const ConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm,
  dialogTitle,
  dialogContent,
  agreeTitle = "Yes",
  disagreeTitle = "No",
}) => {
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [closeLoading, setCloseLoading] = useState(false);
  const { currentTheme } = useSelector((state) => state.theme);

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      PaperProps={{
        sx: {
          backgroundColor: currentTheme === "dark" ? "color-mix(in srgb, #00E5FF 20%, transparent)" : "#fff",
          // border: currentTheme === "dark" ? "1px solid color-mix(in srgb, #00E5FF 50%, #ECFEFFA6)" : "1px solid transparent",
          borderRadius: "16px",
          color: currentTheme === "dark" ? "#fff" : "#000",
        },
      }}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: "rgba(0, 0, 0, 0.7)",
          },
        },
      }}
    >
      {dialogTitle && (
        <DialogTitle
          sx={{
            color: currentTheme === "dark" ? "#fff" : "#000",
          }}
        >
          <span style={{ fontSize: "20px", fontWeight: "300" }}>{dialogTitle}</span>
        </DialogTitle>
      )}
      {dialogContent && (
        <DialogContent
          sx={{
            color: currentTheme === "dark" ? "#fff" : "#000",
          }}
        >
          {dialogContent}
        </DialogContent>
      )}
      <DialogActions>
        <CustomLoadingButton
          currentTheme={currentTheme}
          borderRadiusType="left"
          variant="tint"
          color="#E65100"
          tooltip={disagreeTitle}
          iconPosition="end"
          onClick={async () => {
            setCloseLoading(true);
            try {
              await onClose();
            } catch (error) {
              console.log(error);
            } finally {
              setCloseLoading(false);
            }
          }}
          disabled={confirmLoading}
        >
          {disagreeTitle}
        </CustomLoadingButton>
        <CustomLoadingButton
          currentTheme={currentTheme}
          borderRadiusType="right"
          variant="tint"
          color="#388E3C"
          tooltip={agreeTitle}
          iconPosition="end"
          onClick={async () => {
            setConfirmLoading(true);
            try {
              await onConfirm();
            } catch (error) {
              console.log(error);
            } finally {
              setConfirmLoading(false);
            }
          }}
          disabled={closeLoading}
        >
          {agreeTitle}
        </CustomLoadingButton>

      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
